/* React 綁定。純邏輯在 core.ts，這裡只負責 context 與文件語言屬性。 */
import { createContext, useContext, useEffect, useMemo } from "react";
import type { ReactNode } from "react";
import { buildI18n } from "./core.ts";
import type { I18nValue, Locale } from "./core.ts";

export * from "./core.ts";

const Ctx = createContext<I18nValue | null>(null);

export function I18nProvider(props: { locale: Locale; children: ReactNode }) {
  const value = useMemo(() => buildI18n(props.locale), [props.locale]);
  useEffect(() => {
    document.documentElement.lang = props.locale === "en" ? "en" : "zh-Hant";
  }, [props.locale]);
  return <Ctx.Provider value={value}>{props.children}</Ctx.Provider>;
}

export function useI18n(): I18nValue {
  const v = useContext(Ctx);
  if (!v) throw new Error("元件樹外層缺少 I18nProvider");
  return v;
}
